export const AddressUtilitiesServiceModule = angular
    .module('app.services.utilities.addressUtilities', [])
    .factory('addressUtilities', () => {
        return {
            convertStripeAddress: (stripeAddress) => {
                return {
                    city: stripeAddress.city,
                    postalCode: stripeAddress.zip,
                    state: stripeAddress.state,
                    selectedState: { code: stripeAddress.state },
                    address1: `${stripeAddress.line1} ${stripeAddress.line2 || ''}`
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/addressUtilities.service.js